import { SnippetsType, WidgetConstants } from './widgetConstants';

export const getColorStyles = (color) => {
  if (!color) return {};
  return 'E8E8E8';
};

const TRACK_ORDER_STATE_FOR_ORDER_STATE_MAP = [
  'DELIVERED',
  'CANCELLED',
  'DELIVERY_FAILED',
];

function getHeaderSnippet(response) {
  let snippet = {};
  response.objects?.forEach((widget, index) => {
    if (widget.type === WidgetConstants.TYPE_HEADER_WIDGET) {
      let data = widget.data['header_data'];
      data = {
        ...data,
        padding: '0,16,0,16',
        title: {
          font: {
            weight: 'medium',
            size: '050',
          },
          ...data.title,
        },
        subtitle1: {
          font: {
            weight: 'medium',
            size: '300',
          },
          ...data.subtitle1,
        },
        subtitle2: {
          font: {
            weight: 'extrabold',
            size: '900',
          },
          ...data.subtitle2,
        },
        ...(data.pill_data && {
          pill_data: {
            ...data.pill_data.right_data,
            pill_background_data: {
              bg_color: data.pill_data.bg_color,
              padding: '8,10,8,10',
              corner_radius: 4,
            },
          },
        }),
      };
      snippet = {
        data,
        tracking: widget.tracking,
        widget_type: 'track_order_header_snippet',
        layout_config: {
          // spacing: '12,0,12,0'
        },
      };
    }
  });
  return snippet;
}
function getTimelineSnippet(response) {
  let snippet = {};
  response.objects?.forEach((widget, index) => {
    if (widget.type === WidgetConstants.TYPE_TIMELINE_DATA) {
      let data = widget.data['timeline_data'];
      if (data['order_status_timeline_data']) {
        const snippets = data['order_status_timeline_data'].map(
          (item, index) => {
            let updatedItem = {
              ...item,
              [item.type]: {
                ...item[item.type],
                bg_color: {
                  tint: '500',
                  type: 'white',
                },
                padding: '12,16,12,16',
              },
            };
            return transformWidgetToSnippet(updatedItem);
          },
        );
        if (snippets.length) {
          data['order_status_timeline_data'] = snippets;
        }
      }
      snippet = {
        data,
        tracking: widget?.tracking,
        widget_type: 'timeline_snippet',
        layout_config: {},
      };
    }
  });
  return snippet;
}

function getMapData(response) {
  let mapData = null;
  response.objects?.forEach((widget, index) => {
    if (widget.type === WidgetConstants.TYPE_MAP_TRACKING_WIDGET) {
      mapData = widget.data.map_data;
    }
  });
  return mapData;
}

function transformToCrystalResponse(response) {
  const snippets = [];
  let layoutConfig = { spacing: '12,0,12,0' };
  let pageLayoutConfig = { bg_color_hex: '#E8E8E8' };
  let orderState = response.page_meta?.custom_data?.order_state;

  response.objects?.forEach((widget, index) => {
    let { data, tracking, type } = widget;
    let snippet = {
      layout_config: layoutConfig,
      widget_type: data?.type,
      tracking,
    };

    switch (data?.type) {
      case SnippetsType.crystal_snippet_type_1:
        snippets.push({
          data: {
            bg_color: {
              tint: '500',
              type: 'white',
            },
            padding: '12,16,12,16',
            ...data[data?.type],
            ...data.snippet_config,
            ...(data[data?.type].bottom_separator && {
              bottom_separator: {
                ...data[data?.type].bottom_separator,
                type: 'thick_v2_16',
              },
            }),
          },
          ...snippet,
        });
        break;
      case SnippetsType.crystal_snippet_type_2:
        if (type === WidgetConstants.TYPE_POST_CHECKOUT_PAYMENT_WIDGET) {
          break;
        }
        if (data.snippet_config.identifier === 'APP_RATING') {
          break;
        }
        snippets.push({
          data: {
            bg_color: {
              tint: '500',
              type: 'white',
            },
            padding: '12,16,12,16',
            ...data[data?.type],
            ...data.snippet_config,
            bottom_separator: {
              ...data[data?.type].bottom_separator,
              type: 'thick_v2_16',
            },
          },
          ...snippet,
        });
        break;
      case SnippetsType.crystal_snippet_type_6:
        if (data.snippet_config.identifier === 'KYC_WIDGET') {
          break;
        }
        if (
          tracking?.widget_meta?.title === 'track_order_delivery_partner' &&
          TRACK_ORDER_STATE_FOR_ORDER_STATE_MAP.includes(orderState)
        ) {
          break;
        }
        snippets.push({
          data: {
            bg_color: {
              tint: '500',
              type: 'white',
            },
            padding:
              data.snippet_config.identifier === 'ADDRESS_WIDGET_V2' ||
              data.snippet_config.identifier === 'CONTACT_DETAILS_WIDGET'
                ? '12,12,12,12'
                : '12,16,12,16',
            ...data[data?.type],
            ...data.snippet_config,
            ...(data.snippet_config.identifier === 'RIDER_V16' && {
              left_image: { ...data[data?.type].left_image, width: 48 },
            }),
            ...(data.snippet_config.identifier === 'CONTACT_DETAILS_WIDGET' && {
              button: null,
              bottom_container: null,
            }),
            ...(data.snippet_config.identifier === 'POST_DELIVERY_STATUS' && {
              bottom_radius: data.snippet_config.top_radius,
              title: data[data?.type].title,
              bottom_separator: {
                ...data[data?.type].bottom_separator,
                type: 'thick_v2_16',
              },
            }),
            ...(data.snippet_config.identifier === 'CHAT_SUPPORT' && {
              left_image: { ...data[data?.type].left_image, width: 48 },
            }),
          },
          ...snippet,
        });
        break;
      // case SnippetsType.b_image_text_snippet_type_17:
      case SnippetsType.image_text_tag_snippet:
        const horizontalItemList = widget.data[widget.data?.type].items.map(
          (widgetItem) => {
            if (!widgetItem?.tag)
              return {
                data: widgetItem,
                tracking: {},
                widget_type: data?.type,
              };
            return {};
          },
        );
        snippets.push({
          data: {
            horizontal_item_list: horizontalItemList,
            bg_color_hex: '#FFFFFF',
          },
          ...snippet,
          widget_type: 'horizontal_list',
        });
        break;
      case SnippetsType.rider_tip_snippet:
        if (data.snippet_config.identifier === 'OFSE_DETAILS') {
          snippets.push({
            data: { ...data[data?.type], ...data.snippet_config },
            ...snippet,
          });
        }
      default:
        break;
    }
  });

  return {
    is_success: true,
    response: {
      snippets,
      layout_config: pageLayoutConfig,
    },
  };
}

function transformWidgetToSnippet(widget) {
  let snippet = {};
  let layoutConfig = { spacing: '12,0,12,0' };
  snippet = {
    data: {
      ...widget[widget.type],
      ...widget['snippet_config'],
    },
    layout_config: layoutConfig,
    widget_type: widget.type,
  };
  return snippet;
}

function shouldAddToWidgetsList(widget) {
  return (
    widget.type !== WidgetConstants.TYPE_HEADER_WIDGET &&
    widget.type !== WidgetConstants.TYPE_MAP_TRACKING_WIDGET
  );
}

export {
  transformToCrystalResponse,
  shouldAddToWidgetsList,
  transformWidgetToSnippet,
  getHeaderSnippet,
  getMapData,
  getTimelineSnippet,
};
